import type {FC} from 'react'
import {useParams} from 'react-router-dom'
import templatesData from '../../../data/marketing/marketingTemplatesData'
import BulkRun from '../../universal-components/bulk-run/BulkRun'

interface MarketingBulkRunPageProps {}

const MarketingBulkRunPage: FC<MarketingBulkRunPageProps> = () => {
  const {templateUrl} = useParams()
  const templateItem: any = templatesData.templates.find((item: any) =>
    item.url.includes(templateUrl)
  )
  const title = templateItem.title

  return <BulkRun title={title} templateItem={templateItem} uploadCvs={false} />
}

export default MarketingBulkRunPage
